import { SafetyCertificateFilled } from '@ant-design/icons';
import {
  Alert,
  CardAvatar,
  CardHeader,
  VerticalSpace,
} from '@brokerbay/design-components';
import React from 'react';
import { SUPPORT_EMAIL } from 'utils/constants';

const NoApproverView = () => (
    <VerticalSpace>
      <CardHeader
        title={undefined}
        icon={<CardAvatar icon={SafetyCertificateFilled} />}
      />

      <Alert
        message={
          <p>
            It looks like no Account Owner has been set up for your office.
            <br />
            <br />
            In order to proceed an Account Owner needs to be added for your
            office. Please email{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> for
            assistance.
          </p>
        }
      />
    </VerticalSpace>
  );

export default NoApproverView;
